﻿/*
Global override for window.eval to bypass Knockout.js CSP limitations.
DevExpress Web Report Designer relies on Knockout.js, which executes an initial`eval("this")` check 
on file parse. Because our Content Security Policy forbids 'unsafe-eval', this script
intercepts that specific call and safely returns the window context without exposing the app
to arbitrary string evaluation.
* NOTE: This file MUST be imported before 'knockout' in the component chunk.
*/ 
if (typeof window !== 'undefined') {
    const originalEval = window.eval;
    window.eval = function (stringToEvaluate: string) {
        if (stringToEvaluate === "this") {
            return window;
        }
        if (originalEval) {
            return originalEval(stringToEvaluate);
        }
        throw new Error("Eval is blocked by Content Security Policy");
    };
}